import '@styles/views/csc.less';
/* import AppBannerCSC from '@components/app/appBannerCSC'; */
//import AppAdvantage from '@components/app/appAdvantage';
import AppNewOne from '@/components/app/appNewOne';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
import AppFooter from '@components/app/appFooter';

const NewOne = () => {
  return (
    <div className={'introduce-page'}>
      {/* <AppBannerCSC /> */}
      <AppNewOne />
      <AppFooter />
    </div>
  );
};

export default NewOne;
